export const MAX_SUGGESTIONS = 6;
